/**
 * Shared AES-256-GCM constants used by both frontend and backend
 * encryption/decryption implementations.
 */
/** GCM recommended initialization vector length in bytes. */
export const AES_GCM_IV_LENGTH = 12;
/** AES-GCM authentication tag length in bytes. */
export const AES_GCM_TAG_LENGTH = 16;
/** Algorithm identifier for Node.js crypto (createCipheriv / createDecipheriv). */
export const AES_GCM_ALGORITHM_NODE = 'aes-256-gcm';
/** Algorithm identifier for Web Crypto API (importKey / encrypt / decrypt). */
export const AES_GCM_ALGORITHM_WEB = 'AES-GCM';
//# sourceMappingURL=constants.js.map